import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const LocationDropdown = ({
  dropdownRef,
  isDropdownOpen,
  setIsDropdownOpen,
  filterLocations,
  locations,
  toggleLocationSelection,
  getDisplayText,
  onApply,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        type: "spring",
        stiffness: 80,
        damping: 15,
        duration: 0.3,
        delay: 0.4,
        ease: "easeOut",
      }}
      className="relative mb-4"
      ref={dropdownRef}
    >
      <label className="block text-sm font-QSemiBold text-gray-700 mb-1">
        Locations
      </label>
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="w-[300px] max-[440px]:w-[200px] flex justify-between text-sm font-QSemiBold items-center border border-gray-200 rounded-xl px-4 py-3 text-left bg-gray-50 transition-colors"
      >
        <span className="truncate">{getDisplayText(filterLocations)}</span>
        <i
          className={`ri-arrow-down-s-line text-gray-500 transition-transform ${isDropdownOpen ? "rotate-180" : ""}`}
        ></i>
      </button>

      <AnimatePresence>
        {isDropdownOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute z-50 w-full mt-1 bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden"
          >
            <div className="max-h-48 overflow-y-auto custom-scrollbar">
              {locations.map((location, index) => (
                <div
                  key={location.locationID || index}
                  onClick={() => toggleLocationSelection(location)}
                  className={`px-4 py-3 font-QMedium text-sm cursor-pointer hover:bg-indigo-50 flex items-center ${
                    filterLocations.includes(location)
                      ? "bg-indigo-100 text-indigo-700"
                      : "text-gray-700"
                  }`}
                >
                  <span className="truncate">{location.locationName}</span>
                  {filterLocations.includes(location) && (
                    <i className="ri-check-line ml-auto text-indigo-600"></i>
                  )}
                </div>
              ))}
            </div>

            {filterLocations.length > 0 && (
              <div className="p-3 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={() => {
                    onApply?.();
                    setIsDropdownOpen(false);
                  }}
                  className="w-full text-sm font-QSemiBold text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg transition"
                >
                  Apply
                </button>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default LocationDropdown;
